export default "__VITE_ASSET__BScQjb2R__"